module.exports = __webpack_public_path__ + "static/media/inactive-legend.9bed9b7f.svg";